import React__default from 'react';
import { useModalOverlay, Overlay } from 'react-aria';
import Box from '../Box/Box.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 *
 * Modal is a low-level primitive that helps achieve ecosystem-agnostic, fully accessible modal overlays that can be styled as needed.
 *
 * A modal is an overlay element which blocks interaction with elements outside it, consisting of an overlay container element, and an underlay.
 *
 * The overlay may contain a dialog, or another element such as a menu or listbox when used within a component such as a select or combobox.
 *
 * The underlay is typically a partially transparent element that covers the rest of the screen behind the overlay, and prevents the user from interacting with the elements behind it.
 *
 */
const Modal = ({
  state,
  children,
  ...props
}) => {
  const ref = React__default.useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const {
    modalProps,
    underlayProps
  } = useModalOverlay(props, state, ref);
  return /*#__PURE__*/React__default.createElement(Overlay, null, /*#__PURE__*/React__default.createElement(Box, _extends({
    sx: {
      position: 'fixed',
      zIndex: 100,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(9, 30, 66, 0.49)'
    }
  }, underlayProps), /*#__PURE__*/React__default.createElement(Box, _extends({}, modalProps, {
    ref: ref,
    sx: {
      backgroundColor: 'surface.default.[default]',
      border: '1px solid',
      borderColor: 'border.default'
    }
  }), children)));
};
Modal.displayName = "Modal";
var Modal$1 = Modal;

export { Modal$1 as default };
